export default {
  characters: "Characters",
  release: "Release",
  unrelease: "Unrelease"
};
